import React from "react";
import { Accordion, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Loading } from "../../components";
import { ApiHelper, ArrayHelper, MessageInterface } from "../../helpers";


interface Props {
  refreshKey: string
}


export const MessagesSidebar: React.FC<Props> = props => {

  const [messages, setMessages] = React.useState<MessageInterface[]>(null);
  const [selectedMessage, setSelectedMessage] = React.useState<MessageInterface>(null);

  const init = () => {
    ApiHelper.get("/messages").then((data) => setMessages(data));
  }

  const updateSelected = () => {
    let result: MessageInterface = null;
    const parts = window.location.href.split("?")[0].split("/");
    const id = parseInt(parts[parts.length - 1]);
    messages?.forEach(m => { if (m.id === id) result = m; })
    setSelectedMessage(result);
  }

  React.useEffect(init, [props.refreshKey])
  React.useEffect(updateSelected, [messages, window.location.href]) //eslint-disable-line

  const getMessages = () => {
    if (messages === null) return <Loading />
    else return getMessageAccordion();
  }

  const getMessageAccordion = () => {
    if (messages) {
      const sections: JSX.Element[] = [];
      messages?.forEach(m => { if (!m.category) m.category = "Uncategorized" });
      const cats = ArrayHelper.getStrings(messages, "category");
      cats.forEach(c => {
        const catMessages = ArrayHelper.getAll(messages, "category", c);
        const catContent = getMessagesRows(catMessages);
        sections.push(getSection(c, c, catContent));
      });
      const defaultActiveKey = cats.length > 5 ? "" : cats[0];
      return (<Accordion id={"messagesSidebar"} defaultActiveKey={defaultActiveKey} >{sections}</Accordion>)
    }
  }

  const getSection = (eventKey: string, title: string, contents: JSX.Element) => {
    return (<Card key={eventKey}>
      <Accordion.Toggle eventKey={eventKey}>{title}</Accordion.Toggle>
      <Accordion.Collapse eventKey={eventKey}>
        <Card.Body>{contents}</Card.Body>
      </Accordion.Collapse>
    </Card>)
  }


  const getMessagesRows = (messages: MessageInterface[]) => {
    const result: JSX.Element[] = [];
    messages.forEach(m => {
      let url = "/messages/" + m.id
      if (m.shape !== "16:9") url += "?shape=" + m.shape;
      let className = (m.id === selectedMessage?.id) ? "active" : "";
      result.push(<li key={"m" + m.id} className="nav-item"><Link className={className} to={url}>{m.name || "(no name)"}</Link></li>);
    });
    return (<ul className={"nav flex-column"}>{result}</ul>);
  }

  return (
    <>
      <div className="titlebar">
        <div className="float-right">
          <Link to={"/messages"} className="btn btn-sm btn-success">
            <i className="fas fa-plus"></i> New
          </Link>
        </div>
        <div className="title"><i className="fas fa-list-ul"></i> Messages</div>
      </div>
      {getMessages()}
    </>
  );
};